import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70dd7e06")

_pushScopeId("data-v-70dd7e06")
const _hoisted_1 = { class: "download-wiz" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditDownloadSelectSize = _resolveComponent("EditDownloadSelectSize")
  const _component_EditDownloadSelectOutput = _resolveComponent("EditDownloadSelectOutput")
  const _component_EditDownloadPreview = _resolveComponent("EditDownloadPreview")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModalInner,
      "onUpdate:isShow": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowModalInner = $event)),
      title: "ファイルのダウンロード方法を指定してください",
      isLeftTitle: true,
      isFitSize: true,
      onKeydown: _withKeys(_withModifiers(_ctx.enterAction, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.currentPage == _ctx.page1)
            ? (_openBlock(), _createBlock(_component_EditDownloadSelectSize, {
                key: 0,
                editStore: _ctx.editStore,
                images: _ctx.images,
                onNext: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = _ctx.page2)),
                size: _ctx.state.size,
                "onUpdate:size": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.size = $event))
              }, null, 8, ["editStore", "images", "size"]))
            : _createCommentVNode("", true),
          (_ctx.currentPage == _ctx.page2)
            ? (_openBlock(), _createBlock(_component_EditDownloadSelectOutput, {
                key: 1,
                size: _ctx.state.size,
                images: _ctx.images,
                editStore: _ctx.editStore,
                onBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage = _ctx.page1)),
                outputStyle: _ctx.state.outputStyle,
                "onUpdate:outputStyle": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.outputStyle = $event)),
                onPreview: _ctx.preview,
                onDownload: _ctx.download
              }, null, 8, ["size", "images", "editStore", "outputStyle", "onPreview", "onDownload"]))
            : _createCommentVNode("", true),
          (_ctx.isShowPreview == true)
            ? (_openBlock(), _createBlock(_component_EditDownloadPreview, {
                key: 2,
                isShowPreview: _ctx.isShowPreview,
                "onUpdate:isShowPreview": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowPreview = $event)),
                imagePreview: _ctx.imagePreview,
                onBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowPreview = false))
              }, null, 8, ["isShowPreview", "imagePreview"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})